import { ArrayParam, StringParam, NumberParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS } from '@app/api/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import type { ColumnTitleSchema } from '@app/types/table'
import type { RegistryCurrentListDataSource } from './types'
import type { TableSearchQuerySchema, ColumnTableSearchSchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTableSchema } from '@app/components/ExtendedTable/types'

export const columnTitleSchema: ColumnTitleSchema<RegistryCurrentListDataSource> = {
  trend: 'Направление',
  trendId: 'Код направления',
  purchasingGroup: 'ГЗ',
  purchasingGroupId: 'Код ГЗ',
  commodityGroup: 'Тов. группа',
  commodityGroupId: 'Код тов. группы',
  category: 'Категория',
  categoryId: 'Код категории',
  subcategory: 'Подкатегория',
  subcategoryId: 'Код подкатегории',
  isEPP: 'EPP',
  isCHTM: 'ЧТМ',
  code: 'Код товара',
  name: 'Товар',
  howToMonitor: 'Как проводить мониторинг',
  isRecalculation: 'Пересчет',
  isShortKvi: 'shortKVI',
  isTop1: 'TOP1',
  isInfo: 'Info',
  monitoringSubtypesCount: 'Кол-во подтипов',
  subtypes: 'Подтипы'
}

export const columnSettingSchema: ColumnTableSchema<RegistryCurrentListDataSource> = {
  trend: { customEllipsis: true },
  purchasingGroup: { customEllipsis: true },
  commodityGroup: { customEllipsis: true },
  category: { customEllipsis: true },
  subcategory: { customEllipsis: true },
  name: { customEllipsis: true }
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.status]: ArrayParam,
  [FILTERS_PARAMS_KEYS.productCode]: ArrayParam,
  [FILTERS_PARAMS_KEYS.monitoringSubtypeIds]: ArrayParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<RegistryCurrentListDataSource> = {
  'table-trend': StringParam,
  'table-trendId': StringParam,
  'table-purchasingGroup': StringParam,
  'table-purchasingGroupId': StringParam,
  'table-commodityGroup': StringParam,
  'table-commodityGroupId': StringParam,
  'table-category': StringParam,
  'table-categoryId': StringParam,
  'table-subcategory': StringParam,
  'table-subcategoryId': StringParam,
  'table-code': StringParam,
  'table-name': StringParam,
  'table-howToMonitor': StringParam,
  'table-monitoringSubtypesCount': NumberParam
} as const

const titleWrapperProps = { minWidth: 200 } as const

export const columnsSearchSchema: ColumnTableSearchSchema<RegistryCurrentListDataSource> = {
  trend: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  trendId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  purchasingGroupId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  commodityGroup: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  commodityGroupId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  category: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  categoryId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  subcategory: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  subcategoryId: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  code: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  name: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  howToMonitor: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  monitoringSubtypesCount: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps }
} as const
